import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { getAlarms, updateAlarms } from '@entities/notification/api/notifications';

/**
 * 알림 설정 정보 조회 React Query 훅
 * @param {Object} options - React Query 옵션
 * @returns {UseQueryResult} 알림 설정 정보 (app, email)
 */
function useNotificationAlarmsQuery(options = {}) {
  return useQuery({
    queryKey: ['notificationAlarms'],
    queryFn: getAlarms,
    staleTime: 1000 * 60 * 5, // 5분간 캐싱
    ...options,
  });
}

/**
 * 알림 설정 변경 React Query Mutation 훅
 * @param {Object} options - React Query Mutation 옵션 (onSuccess, onError 등)
 * @returns {UseMutationResult} Mutation 결과
 */
function useUpdateNotificationAlarmsMutation(options = {}) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ app, email }) => updateAlarms(app, email),
    onSuccess: function (data, variables, context) {
      // 성공 시 알림 설정 캐시 갱신
      queryClient.invalidateQueries({ queryKey: ['notificationAlarms'] });
      // 사용자 정의 onSuccess 콜백 실행
      if (options.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },
    ...options,
  });
}

export { useNotificationAlarmsQuery, useUpdateNotificationAlarmsMutation };
